import React from 'react';
import { bool } from 'prop-types';

// TODO: convert this into a proper hook
class BeforeUnload extends React.Component {
  componentDidMount() {
    window.addEventListener('beforeunload', this.handleBeforeUnload);
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
  }

  handleBeforeUnload = event => {
    if (!this.props.showPrompt) return;
    if (!window.popOverClicked) {
      const e = event;
      const dialogText = 'Your information is not saved. Are you sure you want to leave?';
      e.returnValue = dialogText;
      return dialogText;
    }
  };

  render() {
    return null;
  }
}

BeforeUnload.propTypes = {
  showPrompt: bool.isRequired,
};

export default BeforeUnload;

require('/var/lib/jenkins/workspace/borrower-apply-ui_Release_0/src/pages/pi1-1QAAT/pi1-1QAAT.scss');